import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import ActionChainMainTable from "@/components/actionChain/actionChainMainTable";

const ActionChainList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_action_chains">
      <ActionChainMainTable />
    </RestrictedPage>
  );
};

export default ActionChainList;
